import { render, staticRenderFns } from "./MinCard.vue?vue&type=template&id=29e6a48f&scoped=true&"
import script from "./MinCard.vue?vue&type=script&lang=js&"
export * from "./MinCard.vue?vue&type=script&lang=js&"
import style0 from "./MinCard.vue?vue&type=style&index=0&id=29e6a48f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e6a48f",
  null
  
)

export default component.exports